<template>
  <div class="bs-10-001 container mx-auto w-full mb-4">
    <div class="lg:w-full" style="background: #e5e5e5">
      <div class="l-container">
        <div class="w-full md:w-full h-2/3 pt-4">
          <div class="f24-36 sm:mt-6">個人情報の第三者提供等に関するご同意について</div>
        </div>
      </div>
      <div class="w-full pt-5">
        <div style="border: solid 1px #dcdee0"></div>
      </div>

      <div class="l-container sm:pt-8 mt-12">
        <div class="w-full" style="background: #ffffff; border-radius: 10px">
          <div class="grid grid-cols-1 m-auto w-11/12 md:pt-8">
            <div v-if="extSystemCd">
              <div class="f16-24-2 lg:pt-0 md:pt-0 pt-11 text-center">
                ログインした状態で、提携サイトへ遷移いたします。
              </div>
              <div class="f18-27 my-8 sm:mt-0">
                <span class="f20-30" style="color: #222222">ご注意事項</span>
              </div>
              <div class="f14-21">
                ・サービス提供企業ホームページへ遷移後はその他のホームページを閲覧しないでください。
              </div>
              <div class="f14-21">
                ・
                遷移後その他のホームページなどを閲覧されたり、別のブラウザでホームページを閲覧されると特典対象外となる可能性がございます。
              </div>
              <div class="f14-21">
                ・また通信障害が発生すると特典対象外となる可能性がございますので、通信環境がよい環境下でのご購入・申込をお願いいたします。
              </div>
              <div class="f14-21">
                ・cookieが削除されてしまうと特典対象外となりますので、cookieの有効期限内で、またはcookieが削除されない環境下にての購
                入・申込等を完了し
              </div>
              <div class="pl-5 f14-21">てください。</div>
              <div class="f14-21">
                ・ベネポが特典のメニュー・プランにおいて、ベネポの付与は最大で3ヶ月程度お時間いただく場合がございます。
              </div>
              <div class="f14-21">
                ・またメニュー・プランにより付与時期が異なる場合がございます。詳細はメニュー・プランの詳細をご確認ください。
              </div>
              <div class="f14-21">
                ・ご予約内容の確認、ご予約をキャンセルされる場合、宿泊施設に関する質問、予約方法、領収書発行については各予約サイトへお問い合わせくださ
              </div>
              <div class="pl-5 f14-21 pb-5">い。</div>
              <a-divider> </a-divider>
            </div>
            <div class="pt-5 f16-24">
              下記の個人情報の取扱について、同意の上お申し込みください。
            </div>

            <div class="f18-27 my-8 sm:mt-0">
              <span class="f20-30" style="color: #222222"
                >個人情報の第三者提供等に関するご同意について</span
              >
            </div>

            <div class="f16-24">
              今回の会員様による本件メニューのお申込み（以下「本申込み」といいます）にあたり、下記①に記載の会員様の個人情報（以下「個人情報」といいます）を、株式会社ベネフィット・ワン（以下「弊社」といいます）が下記②に記載の第三者に対し提供し、下記③の利用目的の範囲内で当該第三者が個人情報を利用することにつき、会員様のご同意をお願いいたします。
            </div>
            <div class="h-12 mb-12">
              <div class="f16-24-1 text-center mt-8 sm:mt-0">記</div>
            </div>

            <div class="f16-24-1 pt-3">①弊社が第三者に提供する個人情報の内容</div>
            <div class="pt-1 f16-24">
              本申込み及びこの後お申込み画面にて会員様にご入力いただく本申込みに係るすべての情報。
            </div>

            <div class="f16-24-1 pt-3">②弊社が個人情報を提供する第三者</div>
            <div class="pt-1 f16-24">
              メニューの提供において弊社と業務提携関係にあるアフィリエイト・サービス・プロバイダの繋ぎ込みを行っているサービスや宿泊施設等のサービス提供企業（以下、単に「サービス提供企業」といいます）。
            </div>

            <div class="f16-24-1 pt-3">③個人情報の提供を受けた第三者における利用目的</div>
            <div class="pt-1 f16-24">
              サービス提供企業において、本申込みをいただいた会員様等に対し、本件メニューの履行、及びサービスの提供を行うため。
            </div>

            <div class="pt-5 f14-21">
              弊社は、サービス提供企業との間に、個人情報の保護に関する契約を締結しております。
            </div>
            <div class="f14-21">
              詳しくは、<a class="blue" @click="redirectTo"
                >個人情報の取り扱いについて <i class="icon icon-bor-full-screen"></i>
              </a>
              をご覧ください。
            </div>
          </div>
          <div class="mt-16 pb-8">
            <div
              class="buttons flex gap-2 justify-center mt-8 sm:flex-col-reverse sm:items-center"
            >
              <button
                @click="handleBack()"
                style="min-width: 150px"
                class="c-btn btn-white btn-white-width sm:w-9/12"
              >
                <span class="">閉じる</span>
              </button>
              <!-- <button @click="handleNext()" style="min-width:150px" class="c-btn btn-grey sm:w-9/12 ">
                <span class="">上記内容に同意して次へ</span>
              </button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import { BREADCRUMBS } from '@/store/modules/app/actions'
export default {
  name: 'bs_10-001',
  components: {},
  data() {
    return {
      extSystemCd: null,
      breadcrumb_data: [
        'トップ',
        'メニュー名',
        '個人情報の第三者提供等に関するご同意について'
      ]
    }
  },
  mounted() {
    this.$store.dispatch(BREADCRUMBS, [])
    this.extSystemCd = _.get(this.getPlanDetail, 'menuInformation.extSystemCd', null)
  },
  computed: {
    getPlanDetail() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.planDetail', null))
    }
  },
  methods: {
    handleBack() {
      window.close()
    },
    redirectTo() {
      window.open('https://bs.benefit-one.co.jp/BE-ONE/official/handling.html')
    }
  }
}
</script>

<style scoped>
@import './styles.scss';
</style>
